
import {
  TimePicker,
  Flex,
  Select as SelectAntd,
  SelectProps,
  InputProps,
  Input as InputAntd,
  TreeSelect,
  TreeSelectProps
} from 'antd';
import React from 'react'

export interface FilterTreeSelectPcProps extends TreeSelectProps {
  getInitData?():void
}



export const FilterTreeSelectPc = (props: FilterTreeSelectPcProps ) => {
  const {getInitData, ...reset} = props

  React.useEffect(()=>{
    let hasArrayValue = Array.isArray(props.value) && props.value.length 
    if(!props.value || !hasArrayValue){
      return
    }
    setTimeout(()=>{
      props.getInitData && props.getInitData()
    },300)
  },[])
  if(reset.multiple === false){
    reset.treeCheckable = false
  }
  return <TreeSelect
    allowClear
    onFocus={getInitData}
    {...reset}
  />
}
